export enum FieldEditType {
  single,
  multiple
}
